import { Download } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { Button, Skeleton, Typography } from 'antd';

import { useCertificate } from '@/hooks/useCertificate';
import { useCourseProgress } from '@/hooks/useProgress';
import { useGetCourseQuery } from '@/services/course';
import styled, { css, StyledProp } from '@/styled';

import Progress from '../Progress';

const ProgressStatus = (props: StyledProp) => {
  const { hash } = useParams();
  const { progress, watchedLessons, lessons } = useCourseProgress();
  const { data, isLoading } = useGetCourseQuery(hash);
  const certificate = useCertificate(progress);

  return (
    <div className={props.className}>
      {certificate.reached && (
        <Typography.Text className='congratulations'>
          Parabéns, você conquistou seu certificado!
          <Button size='small' icon={<Download />} onClick={certificate.onClick}>
            <Typography.Text underline>Baixar Certificado</Typography.Text>
          </Button>
        </Typography.Text>
      )}
      <Progress percent={progress} showInfo={false} />
      <Typography.Text>
        {!isLoading && `${progress}% concluído: ${watchedLessons} de ${lessons} aulas`}
        {isLoading && <Skeleton.Input size='small' />}
      </Typography.Text>
      <Typography.Text>
        {data?.has_certificate &&
          data?.progress_percent > 0 &&
          `Conclua ${data?.progress_percent}% para obter seu certificado`}
      </Typography.Text>
    </div>
  );
};
export default styled(ProgressStatus)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;

    > div.ant-progress {
      max-width: 359px;
      margin: 0;
      margin-bottom: ${theme.space.pxToRem(14)};
    }

    .congratulations {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: ${theme.space.pxToRem(16)};
      margin-bottom: ${theme.space.pxToRem(22)};

      button {
        border: none;
        background: ${theme.variables.contentCertificateButton.background};
        display: flex;
        align-items: center;

        span {
          margin-left: ${theme.space.pxToRem(8)};
        }
      }
    }
  `
);
